// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
	FILE: _core.scss

	USED ON:
		- srprs.me/*

	USAGE:
		Meant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1

	NOTES:
		NEVER use @import "base/*"; or such, read this => http://stackoverflow.com/a/4779432
*/
.clearfix {
  overflow: auto;
}

.display-flex {
  display: inline;
}
@media only screen and (min-width: 767px) {
  .display-flex {
    display: flex;
  }
}

.full-width {
  width: 100%;
}

@media only screen and (max-width: 767px) {
  .mobile-full-width {
    width: 100%;
  }
}

@media only screen and (min-width: 767px) {
  .width-49 {
    width: 49%;
  }
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.margin-b-s {
  margin-bottom: 10px;
}

.margin-b-m {
  margin-bottom: 20px;
}

.margin-b-l {
  margin-bottom: 40px;
}

.padding-t-s {
  padding-top: 10px;
}

.padding-t-s-7 {
  padding-top: 7px;
}

.padding-l-s {
  padding-left: 10px;
}

.padding-r-s {
  padding-right: 10px;
}

.padding-r-m {
  padding-right: 20px;
}

.padding-r-xl {
  padding-right: 60px;
}

.text-centered {
  text-align: center;
}

.text-bold {
  font-weight: bold;
}

.text-small {
  font-size: 14px;
}

.text-medium {
  font-size: 20px;
}

.text-large {
  font-size: 24px;
}

.text-xlarge {
  font-size: 28px;
}

.text-uppercase {
  text-transform: uppercase;
}

.is-loading,
.loading {
  color: #ececec;
  background-color: #ececec;
}
.is-loading::selection, .is-loading::-moz-selection,
.loading::selection,
.loading::-moz-selection {
  background: #ececec;
}

@media screen and (max-width: ) {
  body:before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 375px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 640px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 768px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1024px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1280px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1440px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1600px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
/*
	usage:

	.element {
		@include browserfix(ie) {
			&:after {
				content: "This is IE only"
			}
		}
		@include browserfix(firefox) {
			&:after {
				content: "Only Firefox users will see this";
			}
		}
	}
*/
@keyframes buttonDisabled {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
.calendar-month {
  position: relative;
  width: 100%;
  overflow: hidden;
  overflow-x: auto;
  /* table heading => day names */
  /* table body => day cells */
}
.calendar-month:before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 24px;
  height: 100%;
  background-image: linear-gradient(to bottom, white 0%, rgba(255, 255, 255, 0) 100%);
  pointer-events: none;
}
.calendar-month::-webkit-scrollbar {
  height: 6px;
}
.calendar-month table {
  width: 170%;
  border-collapse: separate;
  border-spacing: 3px;
  overflow-y: visible;
}
.calendar-month thead th {
  width: 14.2857142857%;
  color: #6f6f6f;
  font-size: 12px;
  padding-right: 12px;
  padding-left: 8px;
}
.calendar-month tbody td {
  position: relative;
  display: table-cell;
  width: 14.2857142857%;
  height: 54px;
  vertical-align: top;
}
.calendar-month tbody td.is-selectable div.is-disabled:hover, .calendar-month tbody td.is-selected div.is-disabled:hover {
  border-color: transparent;
}
.calendar-month tbody td.is-selectable {
  cursor: pointer;
  background-color: #fff;
}
.calendar-month tbody td.is-selectable div:hover {
  transition-property: all;
  transition-duration: 0.25s;
  transition-timing-function: ease-out;
  transition-delay: 0s;
  border-color: var(--colorBackground);
}
.calendar-month tbody td.is-selected {
  /* what to to with selected dates with an availability badge? for now, the badge overlaps the "checked" sign */
}
.calendar-month tbody td.is-selected div {
  border-color: var(--colorBackground);
}
.calendar-month tbody td.is-selected div:not(.is-cheapest):after {
  transition-property: all;
  transition-duration: 0.25s;
  transition-timing-function: ease-out;
  transition-delay: 0s;
  opacity: 1;
  visibility: visible;
}
.calendar-month tbody td.is-selected div:not(.is-cheapest) .srprs-icon {
  transition-property: all;
  transition-duration: 0.25s;
  transition-timing-function: ease-out;
  transition-delay: 0s;
  opacity: 1;
  visibility: visible;
}
.calendar-month tbody td.is-cheapest div:after {
  opacity: 0;
  visibility: hidden;
}
.calendar-month tbody td.full-selected div {
  background-color: var(--colorBackground);
}
.calendar-month tbody td.is-not-selectable {
  pointer-events: none;
}
.calendar-month tbody td.non-month-day div {
  box-shadow: none;
  background-color: #f4f4f4;
}
.calendar-month tbody td div {
  transition-property: all;
  transition-duration: 0.25s;
  transition-timing-function: ease-out;
  transition-delay: 0s;
  position: absolute;
  top: 0;
  left: 0;
  width: calc(100% - 4px);
  height: calc(100% - 4px);
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  align-content: stretch;
  background-color: #fff;
  border-width: 2px;
  border-style: solid;
  border-color: transparent;
  border-bottom-left-radius: 10px;
  box-shadow: 0 0 10px rgba(34, 34, 34, 0.1);
  /* content => display simple, which means "show day-number only, horizontally and vertically centered */
  /* content => display prices, which means "show day-number in upper left, and the price in bold in bottom right */
}
.calendar-month tbody td div:after {
  transition-property: all;
  transition-duration: 0.25s;
  transition-timing-function: ease-out;
  transition-delay: 0s;
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  width: 0;
  height: 0;
  opacity: 0;
  visibility: hidden;
  /* css triangle upper right */
  border-width: 0 30px 30px 0;
  border-style: solid;
  border-color: transparent var(--colorBackground) transparent transparent;
}
.calendar-month tbody td div.display-simple {
  flex-direction: row;
  justify-content: center;
}
.calendar-month tbody td div.display-simple .date-day {
  font-weight: bold;
}
.calendar-month tbody td div.display-prices {
  padding-top: 10px;
  padding-right: 4px;
  padding-bottom: 8px;
  padding-left: 8px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
}
.calendar-month tbody td div.display-prices .date-day {
  margin-bottom: 5px;
}
.calendar-month tbody td div.is-disabled {
  background-color: #fdfdfd;
  border-color: transparent;
  cursor: not-allowed;
}
.calendar-month tbody td div.is-disabled:hover {
  animation-name: buttonDisabled;
  animation-fill-mode: both;
  animation-duration: 0.75s;
  animation-timing-function: cubic-bezier(0.36, 0.07, 0.19, 0.97);
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000px;
}
.calendar-month tbody td div.is-disabled:after {
  display: none;
}
.calendar-month tbody td div.is-disabled .date-day,
.calendar-month tbody td div.is-disabled .date-price {
  color: #e7e7e7;
}
.calendar-month tbody td div.is-disabled .date-availability {
  color: #222;
  background-color: #e7e7e7;
}
.calendar-month tbody td div.is-disabled .srprs-icon {
  display: none;
}
.calendar-month tbody td div .date-day,
.calendar-month tbody td div .date-price {
  line-height: 1em;
}
.calendar-month tbody td div .date-day,
.calendar-month tbody td div .cheapest-day {
  color: #808080;
  font-size: 13px;
}
.calendar-month tbody td div .cheapest-day {
  color: #151515;
  background-color: var(--colorBackground);
  border-radius: 10px;
  padding: 2px 0 2px 5px;
  margin: -6px 0 4px 0;
}
.calendar-month tbody td div .date-price {
  font-size: 13px;
  font-weight: bold;
}
.calendar-month tbody td div .date-availability {
  transition-property: all;
  transition-duration: 0.25s;
  transition-timing-function: ease-out;
  transition-delay: 0s;
  display: inline-block;
  position: absolute;
  top: -6px;
  right: -6px;
  z-index: 3;
  height: 20px;
  padding-right: 8px;
  padding-left: 8px;
  line-height: 20px;
  border-radius: 10px;
  font-size: 12px;
  background-color: var(--colorBackground);
  color: var(--colorForeground);
  text-align: center;
  text-transform: uppercase;
}
.calendar-month tbody td div .srprs-icon {
  transition-property: all;
  transition-duration: 0.25s;
  transition-timing-function: ease-out;
  transition-delay: 0s;
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 2;
  width: 8px;
  height: 8px;
  opacity: 0;
  visibility: hidden;
}
.calendar-month tbody td div .srprs-icon svg * {
  fill: #fff;
}
.calendar-month > .calendar-loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--colorBackground);
  opacity: 0.25;
}

@media screen and (min-width: 375px) {
  .calendar-month table {
    width: 150%;
  }
  .calendar-month table td div .date-price {
    font-size: 14px;
  }
}
@media screen and (min-width: 768px) {
  .calendar-month table {
    width: 100%;
  }
  .calendar-month tbody td {
    height: 75px;
  }
}
@media screen and (min-width: 768px) {
  .calendar-month table {
    width: 100%;
    border-spacing: 6px;
  }
  .calendar-month tbody td div {
    width: calc(100% - 6px);
    height: calc(100% - 6px);
    border-width: 3px;
  }
  .calendar-month tbody td div:after {
    /* css triangle upper right */
    border-width: 0 36px 36px 0;
  }
  .calendar-month tbody td div.display-simple .date-day {
    font-size: 15px;
  }
  .calendar-month tbody td div.display-prices {
    padding: 16px 10px 10px;
  }
  .calendar-month tbody td div .date-day {
    font-size: 15px;
  }
  .calendar-month tbody td div .cheapest-day {
    margin: -8px 0 8px 0;
  }
  .calendar-month tbody td div .date-price {
    font-size: 16px;
  }
  .calendar-month tbody td div .srprs-icon {
    width: 12px;
    height: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./../srprsme-react-components/src/components/_Assets/scss/_core.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/_helpers.scss","webpack://./../srprsme-react-components/src/components/CalendarMonth/CalendarMonth.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_breakpoint.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_browser-fixes.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/animations/_Button.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_transition.scss"],"names":[],"mappings":"AAEA;;;;;;;;;;;CAAA;ACAA;EACE,cAAA;ACWF;;ADRA;EACE,eAAA;ACWF;ADVE;EAFF;IAGI,aAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADTE;EADF;IAEI,WAAA;ECaF;AACF;;ADTE;EADF;IAEI,UAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADVA;EACE,YAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADVA;EACE,gBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADXA;EACE,eAAA;ACcF;;ADZA;EACE,eAAA;ACeF;;ADbA;EACE,eAAA;ACgBF;;ADdA;EACE,eAAA;ACiBF;;ADfA;EACE,yBAAA;ACkBF;;ADfA;;EAEE,cAAA;EACA,yBAAA;ACkBF;ADjBE;;;EAEE,mBAAA;ACoBJ;;ACpFA;EAEI;IACE,iBAAA;IACA,aAAA;EDsFJ;AACF;ACvHI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDoEN;AACF;AC7HI;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED0EN;AACF;ACnII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDgFN;AACF;ACzII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDsFN;AACF;AC/II;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED4FN;AACF;ACrJI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDkGN;AACF;AC3JI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDwGN;AACF;AEzIA;;;;;;;;;;;;;;;CAAA;AChCA;EACE;IAEE,kCAAA;EH0LF;EGxLA;IAEE,iCAAA;EHyLF;EGvLA;IAGE,kCAAA;EHuLF;EGrLA;IAEE,iCAAA;EHsLF;AACF;AAtMA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EA4BA,+BAAA;EAcA,4BAAA;AAgKF;AAzME;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EAEE,mFAAA;EAMF,oBAAA;AAqMJ;AAnME;EACE,WAAA;AAqMJ;AAnME;EACE,WAAA;EAEE,yBAAA;EACA,mBAAA;EAEF,mBAAA;AAmMJ;AA/LI;EACE,qBAAA;EACA,cAAA;EAEE,eAAA;EAGA,mBAAA;EACA,iBAAA;AA8LR;AAxLI;EACE,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;AA0LN;AArLY;EAEI,yBAAA;AAsLhB;AAhLM;EACE,eAAA;EAEE,sBAAA;AAiLV;AA9KU;EIvEN,wBAAA;EACA,0BJuE4B;EItE5B,oCAAA;EAEE,oBANqD;EJ6E7C,oCAAA;AAiLd;AA5KM;EAqBE,8GAAA;AA0JR;AA9KQ;EAEI,oCAAA;AA+KZ;AA1KU;EIxFN,wBAAA;EACA,0BJwF4B;EIvF5B,oCAAA;EAEE,oBANqD;EJ6F/C,UAAA;EACA,mBAAA;AA8KZ;AA5KU;EI9FN,wBAAA;EACA,0BJ8F4B;EI7F5B,oCAAA;EAEE,oBANqD;EJmG/C,UAAA;EACA,mBAAA;AAgLZ;AApKU;EACE,UAAA;EACA,kBAAA;AAsKZ;AAjKQ;EACE,wCAAA;AAmKV;AAhKM;EACE,oBAAA;AAkKR;AA/JQ;EACE,gBAAA;EAEE,yBAAA;AAgKZ;AA5JM;EIpIF,wBAAA;EACA,0BJoIwB;EInIxB,oCAAA;EAEE,oBANqD;EJwInD,kBAAA;EACA,MAAA;EACA,OAAA;EACA,uBAAA;EACA,wBAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EAEE,sBAAA;EAGA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,+BAAA;EAGA,0CAAA;EAqBF,uGAAA;EAUA,iHAAA;AA+HR;AA5JQ;EI3JJ,wBAAA;EACA,0BJ2J0B;EI1J1B,oCAAA;EAEE,oBANqD;EJgKjD,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,6BAAA;EAEE,2BAAA;EACA,mBAAA;EACA,wEAAA;AA+JZ;AA3JQ;EACE,mBAAA;EACA,uBAAA;AA6JV;AA5JU;EAEI,iBAAA;AA6Jd;AAxJQ;EAEI,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EAEF,sBAAA;EACA,2BAAA;EACA,oBAAA;AAwJV;AAvJU;EAEI,kBAAA;AAwJd;AAjJQ;EAEI,yBAAA;EAGA,yBAAA;EAEF,mBAAA;AA+IV;AA9IU;EACE,8BAAA;EACA,yBAAA;EACA,yBAAA;EACA,+DAAA;EACA,wBAAA;EACA,2BAAA;EACA,mBAAA;AAgJZ;AA9IU;EACE,aAAA;AAgJZ;AA9IU;;EAEE,cAAA;AAgJZ;AA9IU;EACE,WAAA;EAEE,yBAAA;AA+Id;AA5IU;EACE,aAAA;AA8IZ;AA3IQ;;EAEE,gBAAA;AA6IV;AA3IQ;;EAEE,cAAA;EAEE,eAAA;AA4IZ;AAzIQ;EACE,cAAA;EACA,wCAAA;EACA,mBAAA;EACA,sBAAA;EACA,oBAAA;AA2IV;AAzIQ;EAEI,eAAA;EACA,iBAAA;AA0IZ;AAvIQ;EItQJ,wBAAA;EACA,0BJsQ0B;EIrQ1B,oCAAA;EAEE,oBANqD;EJ2QjD,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EAEE,kBAAA;EACA,iBAAA;EAEF,iBAAA;EAEE,mBAAA;EAGA,eAAA;EAGA,wCAAA;EAEF,6BAAA;EAEE,kBAAA;EACA,yBAAA;AAkIZ;AA/HQ;EInSJ,wBAAA;EACA,0BJmS0B;EIlS1B,oCAAA;EAEE,oBANqD;EJwSjD,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;AAmIV;AAjIY;EACE,UAAA;AAmId;AA5HE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EAEE,wCAAA;EAEF,aAAA;AA4HJ;;AC1bI;EDoUA;IACE,WAAA;EA0HJ;EAvHQ;IAEI,eAAA;EAwHZ;AACF;ACncI;EDqVA;IACE,WAAA;EAiHJ;EA9GI;IACE,YAAA;EAgHN;AACF;AC3cI;EDkWA;IACE,WAAA;IAEE,mBAAA;EA2GN;EAtGM;IACE,uBAAA;IACA,wBAAA;IAEE,iBAAA;EAuGV;EArGQ;IACE,6BAAA;IAEE,2BAAA;EAsGZ;EAlGU;IAEI,eAAA;EAmGd;EA/FQ;IACE,uBAAA;EAiGV;EA/FQ;IAEI,eAAA;EAgGZ;EA7FQ;IACE,oBAAA;EA+FV;EA7FQ;IAEI,eAAA;EA8FZ;EA3FQ;IACE,WAAA;IACA,YAAA;EA6FV;AACF","sourcesContent":["@charset \"UTF-8\";\n\n/*\n\tFILE: _core.scss\n\n\tUSED ON:\n\t\t- srprs.me/*\n\n\tUSAGE:\n\t\tMeant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1\n\n\tNOTES:\n\t\tNEVER use @import \"base/*\"; or such, read this => http://stackoverflow.com/a/4779432\n*/\n\n// vars & helpers\n@import 'helpers/variables';\n@import 'helpers/helpers';\n\n// functions\n@import 'helpers/functions/map-deep-get';\n@import 'helpers/functions/color';\n@import 'helpers/functions/font';\n//@import \"helpers/functions/padding\";\n@import 'helpers/functions/section';\n@import 'helpers/functions/str-replace';\n@import 'helpers/functions/z-index';\n\n// mixins\n@import 'helpers/mixins/arrow';\n@import 'helpers/mixins/aspect-ratio';\n@import 'helpers/mixins/breakpoint';\n@import 'helpers/mixins/browser-fixes';\n@import 'helpers/mixins/color-schemes';\n@import 'helpers/mixins/grid';\n@import 'helpers/mixins/no-bullets';\n@import 'helpers/mixins/clearfix';\n@import 'helpers/mixins/font-face';\n@import 'helpers/mixins/scrollbars';\n@import 'helpers/mixins/transform-center';\n@import 'helpers/mixins/transition';\n@import 'helpers/mixins/truncate';\n\n// repeatables (aka think DRY and store it in an @mixin)\n@import 'helpers/repeatables/box-shadow';\n@import 'helpers/repeatables/iphonex';\n@import 'helpers/repeatables/wrapper-inner';\n\n// animations\n@import 'animations/Button';\n","@charset \"UTF-8\";\n\n.clearfix {\n  overflow: auto;\n}\n\n.display-flex {\n  display: inline;\n  @media only screen and (min-width: 767px) {\n    display: flex;\n  }\n}\n\n.full-width {\n  width: 100%;\n}\n\n.mobile-full-width {\n  @media only screen and (max-width: 767px) {\n    width: 100%;\n  }\n}\n\n.width-49 {\n  @media only screen and (min-width: 767px) {\n    width: 49%;\n  }\n}\n\n.pull-left {\n  float: left;\n}\n\n.pull-right {\n  float: right;\n}\n\n.margin-b-s {\n  margin-bottom: 10px;\n}\n\n.margin-b-m {\n  margin-bottom: 20px;\n}\n\n.margin-b-l {\n  margin-bottom: 40px;\n}\n\n.padding-t-s {\n  padding-top: 10px;\n}\n\n.padding-t-s-7 {\n  padding-top: 7px;\n}\n\n.padding-l-s {\n  padding-left: 10px;\n}\n\n.padding-r-s {\n  padding-right: 10px;\n}\n\n.padding-r-m {\n  padding-right: 20px;\n}\n\n.padding-r-xl {\n  padding-right: 60px;\n}\n\n.text-centered {\n  text-align: center;\n}\n\n.text-bold {\n  font-weight: bold;\n}\n.text-small {\n  font-size: 14px;\n}\n.text-medium {\n  font-size: 20px;\n}\n.text-large {\n  font-size: 24px;\n}\n.text-xlarge {\n  font-size: 28px;\n}\n.text-uppercase {\n  text-transform: uppercase;\n}\n\n.is-loading,\n.loading {\n  color: #ececec;\n  background-color: #ececec;\n  &::selection,\n  &::-moz-selection {\n    background: #ececec;\n  }\n}\n","@charset \"UTF-8\";\n@import '../_Assets/scss/core';\n\n.calendar-month {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  overflow-x: auto;\n  &:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 24px;\n    height: 100%;\n    background: {\n      image: linear-gradient(\n        to bottom,\n        rgba(color(white), 1) 0%,\n        rgba(color(white), 0) 100%\n      );\n    }\n    pointer-events: none;\n  }\n  &::-webkit-scrollbar {\n    height: 6px;\n  }\n  table {\n    width: 170%;\n    border: {\n      collapse: separate;\n      spacing: 3px;\n    }\n    overflow-y: visible;\n  }\n  /* table heading => day names */\n  thead {\n    th {\n      width: calc(100% / 7);\n      color: lighten(color(black), 30%);\n      font: {\n        size: 12px;\n      }\n      padding: {\n        right: 12px;\n        left: 8px;\n      }\n    }\n  }\n  /* table body => day cells */\n  tbody {\n    td {\n      position: relative; // needed for safari, to make the children \"position: absolute;\"\n      display: table-cell;\n      width: calc(100% / 7);\n      height: 54px;\n      vertical-align: top;\n      &.is-selectable,\n      &.is-selected {\n        div {\n          &.is-disabled {\n            &:hover {\n              border: {\n                color: transparent;\n              }\n            }\n          }\n        }\n      }\n      &.is-selectable {\n        cursor: pointer;\n        background: {\n          color: color(white);\n        }\n        div {\n          &:hover {\n            @include transition(0.25s);\n\n            border: {\n              color: var(--colorBackground);\n            }\n          }\n        }\n      }\n      &.is-selected {\n        div {\n          border: {\n            color: var(--colorBackground);\n          }\n        }\n\n        div:not(.is-cheapest) {\n          &:after {\n            @include transition(0.25s);\n\n            opacity: 1;\n            visibility: visible;\n          }\n          .srprs-icon {\n            @include transition(0.25s);\n\n            opacity: 1;\n            visibility: visible;\n          }\n        }\n        /* what to to with selected dates with an availability badge? for now, the badge overlaps the \"checked\" sign */\n        //.date-availability {\n        //\t@include transition(.25s);\n        //\tright: auto;\n        //\tleft: -6px;\n        //}\n      }\n      &.is-cheapest {\n        div {\n          &:after {\n            opacity: 0;\n            visibility: hidden;\n          }\n        }\n      }\n      &.full-selected {\n        div {\n          background-color: var(--colorBackground);\n        }\n      }\n      &.is-not-selectable {\n        pointer-events: none;\n      }\n      &.non-month-day {\n        div {\n          box-shadow: none;\n          background: {\n            color: lighten(color(grey-light), 5%);\n          }\n        }\n      }\n      div {\n        @include transition(0.25s);\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: calc(100% - 4px);\n        height: calc(100% - 4px);\n        display: flex;\n        flex-wrap: nowrap;\n        align-items: center;\n        align-content: stretch;\n        background: {\n          color: color(white);\n        }\n        border: {\n          width: 2px;\n          style: solid;\n          color: transparent;\n          bottom-left-radius: 10px;\n        }\n        box: {\n          shadow: 0 0 10px rgba(color(black), 0.1);\n        }\n        &:after {\n          @include transition(0.25s);\n\n          content: '';\n          position: absolute;\n          top: 0;\n          right: 0;\n          z-index: 1;\n          width: 0;\n          height: 0;\n          opacity: 0;\n          visibility: hidden;\n          /* css triangle upper right */\n          border: {\n            width: 0 30px 30px 0;\n            style: solid;\n            color: transparent var(--colorBackground) transparent transparent;\n          }\n        }\n        /* content => display simple, which means \"show day-number only, horizontally and vertically centered */\n        &.display-simple {\n          flex-direction: row;\n          justify-content: center;\n          .date-day {\n            font: {\n              weight: bold;\n            }\n          }\n        }\n        /* content => display prices, which means \"show day-number in upper left, and the price in bold in bottom right */\n        &.display-prices {\n          padding: {\n            top: 10px;\n            right: 4px;\n            bottom: 8px;\n            left: 8px;\n          }\n          flex-direction: column;\n          justify-content: flex-start;\n          align-items: stretch;\n          .date-day {\n            margin: {\n              bottom: 5px;\n            }\n          }\n          .date-price {\n            // ...\n          }\n        }\n        &.is-disabled {\n          background: {\n            color: #fdfdfd;\n          }\n          border: {\n            color: transparent;\n          }\n          cursor: not-allowed;\n          &:hover {\n            animation-name: buttonDisabled;\n            animation-fill-mode: both;\n            animation-duration: 0.75s;\n            animation-timing-function: cubic-bezier(0.36, 0.07, 0.19, 0.97);\n            transform: translateZ(0);\n            backface-visibility: hidden;\n            perspective: 1000px;\n          }\n          &:after {\n            display: none;\n          }\n          .date-day,\n          .date-price {\n            color: #e7e7e7;\n          }\n          .date-availability {\n            color: color(black);\n            background: {\n              color: color(grey-light);\n            }\n          }\n          .srprs-icon {\n            display: none;\n          }\n        }\n        .date-day,\n        .date-price {\n          line-height: 1em;\n        }\n        .date-day,\n        .cheapest-day {\n          color: #808080;\n          font: {\n            size: 13px;\n          }\n        }\n        .cheapest-day {\n          color: #151515;\n          background-color: var(--colorBackground);\n          border-radius: 10px;\n          padding: 2px 0 2px 5px;\n          margin: -6px 0 4px 0;\n        }\n        .date-price {\n          font: {\n            size: 13px;\n            weight: bold;\n          }\n        }\n        .date-availability {\n          @include transition(0.25s);\n\n          display: inline-block;\n          position: absolute;\n          top: -6px;\n          right: -6px;\n          z-index: 3;\n          height: 20px;\n          padding: {\n            right: 8px;\n            left: 8px;\n          }\n          line-height: 20px;\n          border: {\n            radius: 10px;\n          }\n          font: {\n            size: 12px;\n          }\n          background: {\n            color: var(--colorBackground);\n          }\n          color: var(--colorForeground);\n          text: {\n            align: center;\n            transform: uppercase;\n          }\n        }\n        .srprs-icon {\n          @include transition(0.25s);\n\n          position: absolute;\n          top: 5px;\n          right: 5px;\n          z-index: 2;\n          width: 8px;\n          height: 8px;\n          opacity: 0;\n          visibility: hidden;\n          svg {\n            * {\n              fill: color(white);\n            }\n          }\n        }\n      }\n    }\n  }\n  > .calendar-loader {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: {\n      color: var(--colorBackground);\n    }\n    opacity: 0.25;\n  }\n}\n\n@include breakpoint(mobile-large) {\n  .calendar-month {\n    table {\n      width: 150%;\n      td {\n        div {\n          .date-price {\n            font: {\n              size: 14px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@include breakpoint(tablet-portrait) {\n  .calendar-month {\n    table {\n      width: 100%;\n    }\n    tbody {\n      td {\n        height: 75px;\n      }\n    }\n  }\n}\n\n@include breakpoint(tablet-portrait) {\n  .calendar-month {\n    table {\n      width: 100%;\n      border: {\n        spacing: 6px;\n      }\n    }\n    tbody {\n      td {\n        div {\n          width: calc(100% - 6px);\n          height: calc(100% - 6px);\n          border: {\n            width: 3px;\n          }\n          &:after {\n            /* css triangle upper right */\n            border: {\n              width: 0 36px 36px 0;\n            }\n          }\n          &.display-simple {\n            .date-day {\n              font: {\n                size: 15px;\n              }\n            }\n          }\n          &.display-prices {\n            padding: 16px 10px 10px;\n          }\n          .date-day {\n            font: {\n              size: 15px;\n            }\n          }\n          .cheapest-day {\n            margin: -8px 0 8px 0;\n          }\n          .date-price {\n            font: {\n              size: 16px;\n            }\n          }\n          .srprs-icon {\n            width: 12px;\n            height: 12px;\n          }\n        }\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n$breakpoints: map-deep-get($srprsreactwebsite-config, 'breakpoints');\n\n@mixin breakpoint($screensize) {\n  @if map-has-key($breakpoints, $screensize) {\n    @media screen and (min-width: map-get($breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (min-width: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$height-breakpoints: map-deep-get(\n  $srprsreactwebsite-config,\n  'height-breakpoints'\n);\n\n@mixin height-breakpoint($screensize) {\n  @if map-has-key($height-breakpoints, $screensize) {\n    @media screen and (max-height: map-get($height-breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (max-height: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$breakpoint-initial: map-deep-get(\n  $srprsreactwebsite-config,\n  'breakpoints',\n  's'\n);\n@media screen and (max-width: $breakpoint-initial) {\n  body {\n    &:before {\n      content: 'mobile';\n      display: none;\n    }\n  }\n}\n\n@each $breakpoint, $screensize in $breakpoints {\n  @include breakpoint(#{$screensize}) {\n    body {\n      &::before {\n        @if $breakpoint ==\n          l or\n          $breakpoint ==\n          xl or\n          $breakpoint ==\n          xxl or\n          $breakpoint ==\n          xxxl\n        {\n          content: 'desktop';\n        } @else if $breakpoint == m {\n          content: 'tablet';\n        } @else {\n          content: 'mobile';\n        }\n        display: none;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n// we should thank http://browserhacks.com/ for this great roundup of dirt\n\n@mixin browserfix($browser) {\n  @if ($browser == 'ie') {\n    // the allmighty IE, 10 and up. 9 and lower requires usage of conditional comments, just stash your code in assets/styles/ie.scss\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      @content;\n    }\n  } @else if ($browser == 'firefox') {\n    // firefox 3 and up\n    @-moz-document url-prefix() {\n      @content;\n    }\n  } @else if ($browser == 'opera') {\n    // opera 9.5 and up\n    _:-o-prefocus,\n    body:last-child .selector {\n      @content;\n    }\n  } @else if ($browser == 'safari') {\n    // all safari\n    .selector:not(*:root) {\n      @content;\n    }\n  } @else if ($browser == 'chrome') {\n    // chrome 28 and up\n    @supports (-webkit-appearance: none) {\n      @content;\n    }\n  }\n}\n\n/*\n\tusage:\n\n\t.element {\n\t\t@include browserfix(ie) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"This is IE only\"\n\t\t\t}\n\t\t}\n\t\t@include browserfix(firefox) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"Only Firefox users will see this\";\n\t\t\t}\n\t\t}\n\t}\n*/\n","@charset \"UTF-8\";\n\n@keyframes buttonDisabled {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n  }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}\n","@charset \"UTF-8\";\n\n@mixin transition($transition-duration, $transition-delay: 0s) {\n  transition: {\n    property: all;\n    duration: $transition-duration;\n    timing-function: ease-out;\n    @if $transition-delay {\n      delay: $transition-delay;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
